import React, { forwardRef } from "react";
import SignatureCanvasLib from "react-signature-canvas";

const SignatureCanvas = forwardRef((props, ref) => {
    return (
        <SignatureCanvasLib
            ref={ref}
            penColor="black"
            minWidth={1}
            maxWidth={2.5}
            canvasProps={{
                className:
                    "w-full h-56 rounded-lg border border-gray-300 bg-white",
            }}
            {...props}
        />
    );
});

export default SignatureCanvas;